// ── 24 Tailwind accent colour swatches ───────────────────────────────
export const COLOR_SWATCHES = [
  { name: "Red",       value: "#ef4444" },
  { name: "Orange",    value: "#f97316" },
  { name: "Amber",     value: "#f59e0b" },
  { name: "Yellow",    value: "#eab308" },
  { name: "Lime",      value: "#84cc16" },
  { name: "Green",     value: "#22c55e" },
  { name: "Emerald",   value: "#10b981" },
  { name: "Teal",      value: "#14b8a6" },
  { name: "Cyan",      value: "#06b6d4" },
  { name: "Sky",       value: "#0ea5e9" },
  { name: "Blue",      value: "#3b82f6" },
  { name: "Indigo",    value: "#6366f1" },
  { name: "Violet",    value: "#8b5cf6" },
  { name: "Purple",    value: "#a855f7" },
  { name: "Fuchsia",   value: "#d946ef" },
  { name: "Neutral",   value: "#737373" },
  { name: "Rose",      value: "#f43f5e" },
  { name: "Coral",     value: "#fb7185" },
  { name: "Lavender",  value: "#a78bfa" },
  { name: "Mint",      value: "#34d399" },
  { name: "Slate",     value: "#64748b" },
  { name: "Gray",      value: "#6b7280" },
  { name: "Zinc",      value: "#71717a" },
  { name: "Stone",     value: "#78716c" },
];

// ── Dark / Light ─────────────────────────────────────────────────────
let theme = $state(localStorage.getItem("snapshot_theme") || "dark");

export function getTheme() { return theme; }

export function setTheme(t) {
  theme = t;
  localStorage.setItem("snapshot_theme", t);
  applyTheme();
}

export function toggleTheme() {
  setTheme(theme === "dark" ? "light" : "dark");
}

// ── Accent colour ────────────────────────────────────────────────────
let accentColor = $state(localStorage.getItem("snapshot_accent") || "#52525b"); // zinc-600

export function getAccentColor() { return accentColor; }

export function setAccentColor(color) {
  accentColor = color;
  localStorage.setItem("snapshot_accent", color);
  applyAccentColor(color);
}

// ── Helpers ──────────────────────────────────────────────────────────
function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
}

function darken(hex, amount) {
  const { r, g, b } = hexToRgb(hex);
  const f = 1 - amount;
  return `#${Math.round(r * f).toString(16).padStart(2, "0")}${Math.round(g * f).toString(16).padStart(2, "0")}${Math.round(b * f).toString(16).padStart(2, "0")}`;
}

function luminance(hex) {
  const { r, g, b } = hexToRgb(hex);
  return 0.299 * r + 0.587 * g + 0.114 * b;
}

function applyAccentColor(color) {
  const root = document.documentElement;
  const { r, g, b } = hexToRgb(color);
  root.style.setProperty("--snap-accent", `${r} ${g} ${b}`);
  root.style.setProperty("--snap-accent-hex", color);
  root.style.setProperty("--snap-accent-hover", darken(color, 0.15));
  root.style.setProperty("--snap-accent-active", darken(color, 0.25));
  root.style.setProperty("--snap-accent-fg", luminance(color) > 160 ? "#18181b" : "#ffffff");
}

function applyTheme() {
  document.documentElement.classList.toggle("light", theme === "light");
  document.documentElement.classList.toggle("dark", theme === "dark");
}

// ── Init on load ─────────────────────────────────────────────────────
applyTheme();
applyAccentColor(accentColor);

// Sync across tabs
window.addEventListener("storage", (e) => {
  if (e.key === "snapshot_theme") { theme = e.newValue || "dark"; applyTheme(); }
  if (e.key === "snapshot_accent") { accentColor = e.newValue || "#52525b"; applyAccentColor(accentColor); }
});
